export interface ICheerioCompiler {
    masterProjectBaseName: string
    masterFolderBaseName: string
    tmpFolderBaseName: string
    newHTMLBaseName:  string
    newHTMLWebPath: string
}